module.exports = __webpack_public_path__ + "img/hr-green-asterisk-11.775b0889.png";